import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <a href="https://ananeos.com" className="footer__brand-link" target="_blank" rel="noopener noreferrer">
            <img
              src="/logos/ananeos-logo-full-dark-1200.png"
              alt="Ananeos"
              className="footer__logo"
              loading="lazy"
              width="220"
            />
          </a>
          <p className="footer__tagline">{t('footer.tagline')}</p>
          <p className="footer__by">{t('footer.anAnaneosProduct')}</p>
        </div>

        <div className="footer__cols">
          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.product')}</h4>
            <a href="#features">{t('nav.features')}</a>
            <a href="#how">{t('nav.howItWorks')}</a>
            <a href="#faq">{t('nav.faq')}</a>
            <a href="#waitlist">{t('nav.joinWaitlist')}</a>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.company')}</h4>
            <a href="https://ananeos.com" target="_blank" rel="noopener noreferrer">Ananeos</a>
            <a href="mailto:hello@ananeos.com">hello@ananeos.com</a>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.legal')}</h4>
            <Link to="/privacy">{t('footer.privacy')}</Link>
            <Link to="/terms">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
      <div className="container footer__bottom">
        <span>{t('footer.copyright', { year })}</span>
      </div>
    </footer>
  );
}
